import React, { useState } from "react";
import "./css/Carousal.css"; // Save the CSS in this file
import youtubeShortsImage from "../images/carousal/YoutubeShorts.jpg";
import youtubeVideos from "../images/carousal/YoutubeVideos.jpg";
import YoutubeCommunity from "../images/carousal/YoutubeCommunity.jpg";

const Carousal = () => {
  const [theme, setTheme] = useState(false);

  const handleThemeToggle = () => {
    setTheme(!theme);
  };

  return (
    <div className={`container ${theme ? "blue" : ""}`}>
      <input
        type="radio"
        name="slider"
        id="item-1"
        defaultChecked
        onChange={handleThemeToggle}
      />
      <input type="radio" name="slider" id="item-2" onChange={handleThemeToggle} />
      <input type="radio" name="slider" id="item-3" onChange={handleThemeToggle} />
      <div className="cards">
        <label className="card" htmlFor="item-1" id="song-1">
          <img
            src={youtubeShortsImage}
            alt="song"
          />
        <p>YouTube Shorts</p>
        </label>
        <label className="card" htmlFor="item-2" id="song-2">
          <img
            src={youtubeVideos}
            alt="song"
          />
          <p>YouTube Videos</p>
        </label>
        <label className="card" htmlFor="item-3" id="song-3">
          <img
            src={YoutubeCommunity}
            alt="song"
          />
          <p>YouTube Community</p>
        </label>
      </div>
      {/* <div className="player">
        <div className="upper-part">
          <div className="play-icon">
            <svg
              width="20"
              height="20"
              fill="#2992dc"
              stroke="#2992dc"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="feather feather-play"
              viewBox="0 0 24 24"
            >
              <path d="M5 3l14 9-14 9V3z" />
            </svg>
          </div>
          <div className="info-area" id="test">
            <label className="song-info" id="song-info-1">
              <div className="title">Bunker</div>
              <div className="sub-line">
                <div className="subtitle">Balthazar</div>
                <div className="time">4.05</div>
              </div>
            </label>
            <label className="song-info" id="song-info-2">
              <div className="title">Words Remain</div>
              <div className="sub-line">
                <div className="subtitle">Moderator</div>
                <div className="time">4.05</div>
              </div>
            </label>
            <label className="song-info" id="song-info-3">
              <div className="title">Falling Out</div>
              <div className="sub-line">
                <div className="subtitle">Otzeki</div>
                <div className="time">4.05</div>
              </div>
            </label>
          </div>
        </div>
        <div className="progress-bar">
          <span className="progress"></span>
        </div>
      </div> */}
    </div>
  );
};

export default Carousal;